module.exports = {

    version: 14,


    title: 'PlatO / Cartographie du spectacle jeune public en Pays de la Loire',
    header: 'Cartographie du Jeune Public en Pays de la Loire',
    header_short: 'Cartographie JP en Pays de la Loire',
    noResults: 'Aucun résultat ne correspond à votre recherche.',
    help: 'Aide',
    more: 'En savoir plus',
    about: 'À propos',
    export: 'Exporter',
    fullscreen: 'Plein écran',
    loading: 'Cartographie du spectacle jeune public en Pays de la Loire',
    javascript: 'Cette page nécessite l\'activation de javascript pour être affichée correctement.',
    internet_explorer: 'Ce site nécessite un navigateur moderne pour être affiché correctement, il n\'est pas compatible avec les versions 11 et inférieures d\'internet explorer.',
    back_to_map: 'Retour à la carte',

}
